import { POPUPS } from '@common/constants/popups';
import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';

import { PopupContext } from '@app/dev/contexts/popup';
import Config from '@app/dev/config/main';
import { useTranslation } from '@common/hooks/translation';
import TooltipDropDown from '@common/components/tooltipDropDown';

import { useNavigate } from 'react-router-dom';
import './style.scss';
import { signInParams, signInType, signInPopupType } from '@app/dev/helpers/user';

const User = () => {
  const [{ openPopup }] = useContext(PopupContext);
  const navigate = useNavigate();

  const user = useSelector((state) => state.user);
  const { profile, loggedIn, loggedInByRFID, rfid, freeBonuses } = user;

  const userLoggedin = loggedInByRFID || loggedIn;
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslation();

  const getUserFullName = () => {
    if (!profile || !profile?.first_name) return `${t('Username')}`;

    return `${profile.first_name}.${profile.last_name}`;
  };

  const logOut = () => openPopup(POPUPS.LOGOUT_CONFIRMATION);

  const optionsData = [
    {
      buttonName: `${t('User ID')}: ${profile?.id}`,
      iconName: 'icon-disabled',
      enabled: true,
      className: 'disabled',
    },
    {
      buttonName: 'Change password',
      iconName: 'icon-passkey',
      enabled: Config.userSection.sections.includes('changePassword'),
      callback: () => {
        openPopup(POPUPS.CHANGE_PASSWORD_FORM, { user });
      },
    },
    {
      buttonName: 'Bet History',
      iconName: 'icon-history',
      enabled: Config.userSection.sections.includes('betHistory'),
      callback: () => navigate('/bethistory'),
    },
    {
      buttonName: 'Change pin code',
      iconName: 'icon-change-pin',
      enabled: Config.userSection.sections.includes('changePin'),
      callback: () => {
        openPopup(POPUPS.SET_PIN_CODE, { rfid, loggedIn: true });
      },
    },
    {
      buttonName: t('Free bets'),
      iconName: 'icon-free-bonus',
      badge: freeBonuses.length,
      // enabled: Config.userSection.sections.includes('freeBets') && !!freeBonuses.length,
      enabled: false,
      callback: () => navigate('/freebets'),
    },
    {
      buttonName: 'Log out',
      iconName: 'icon-logout',
      enabled: true,
      callback: () => logOut(),
    },
  ];

  const menuHeader = (
    <>
      <div className="profile-icon-wrp">
        <i className="global-icon icon-profile-icon icon-profile" />
        {!!freeBonuses.length && <span className="profile-icon-badge" />}
      </div>
      <h2>{getUserFullName()}</h2>
      <i className={`menu-toggle-icon global-icon ${isOpen ? 'icon-thin-arrow-up' : 'icon-thin-arrow-down'}`} />
    </>
  );

  if (Config.terminal.enableSignOutWithRfidButton) {
    if (signInType && !userLoggedin) {
      return (
        <div className="sign-in" onClick={() => openPopup(signInPopupType, signInParams)}>
          <i className="global-icon icon-login" />
          <p>{t('Sign In')}</p>
        </div>
      );
    }

    if (signInType === 'cpf' && userLoggedin) {
      return (
        <div className="sign-out">
          <div className="profile-block">
            <i className="global-icon icon-profile" />
          </div>
          <p>{getUserFullName()}</p>
          <i className="global-icon icon-logout" onClick={logOut} />
        </div>
      );
    }

    if (userLoggedin) {
      return (
        <TooltipDropDown
          header={menuHeader}
          options={optionsData}
          className="user-dropdown-section"
          onToggle={setIsOpen}
        />
      );
    }

    return null;
  }
};

export default User;
